<template>
 <ul class="px-[10px]">
    <TokenCard
      v-for="value in tokens.items"
      :key="value.id"
      :token="value" />
  </ul>
</template>

<script>
import TokenCard from '@/components/common/TokenCard.vue';

export default {
  name: 'AllTokensList',
  components: {
    TokenCard,
  },
  props: {
    tokens: {
      type: Object,
      default: () => ({ items: [] })
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
